import React from 'react';
import {Body, designSystemToken} from '@lightricks/react-design-system';
import translate from '@/utils/translate';
import InfoTooltip from '@/components/info-tooltip';

const HINT_KEY =
  '**bold**, _italic_, [link](url), double newline for paragraphs';

type MarkdownFormattingHintProps = {
  variant?: 'inline' | 'tooltip';
};

function MarkdownFormattingHint({
  variant = 'inline',
}: MarkdownFormattingHintProps) {
  if (variant === 'tooltip') {
    return (
      <InfoTooltip
        testID="markdown-formatting-hint"
        title={translate(HINT_KEY)}
      />
    );
  }

  return (
    <Body size="md" color={designSystemToken('semantic.fg.secondary')}>
      {translate(HINT_KEY)}
    </Body>
  );
}

export default MarkdownFormattingHint;
